// Shared filter option lists for the institution dataset, consumed by the
// filter/sort view (FilterBar renders the controls, CollegeTable maps stored
// codes back to human-readable labels in cells).
//
// PORTABLE: this file is intended to ship verbatim into the public-facing
// CoverageReport app alongside FilterBar.vue / CollegeTable.vue. Keep it free
// of CurriculumFinder-specific concerns.

// U.S. states plus DC and the territories that appear in the dataset, in
// alphabetical order by name.
export const states = [
  { name: 'Alabama', code: 'AL' },
  { name: 'Alaska', code: 'AK' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'Arizona', code: 'AZ' },
  { name: 'Arkansas', code: 'AR' },
  { name: 'California', code: 'CA' },
  { name: 'Colorado', code: 'CO' },
  { name: 'Connecticut', code: 'CT' },
  { name: 'Delaware', code: 'DE' },
  { name: 'District of Columbia', code: 'DC' },
  { name: 'Florida', code: 'FL' },
  { name: 'Georgia', code: 'GA' },
  { name: 'Guam', code: 'GU' },
  { name: 'Hawaii', code: 'HI' },
  { name: 'Idaho', code: 'ID' },
  { name: 'Illinois', code: 'IL' },
  { name: 'Indiana', code: 'IN' },
  { name: 'Iowa', code: 'IA' },
  { name: 'Kansas', code: 'KS' },
  { name: 'Kentucky', code: 'KY' },
  { name: 'Louisiana', code: 'LA' },
  { name: 'Maine', code: 'ME' },
  { name: 'Maryland', code: 'MD' },
  { name: 'Massachusetts', code: 'MA' },
  { name: 'Michigan', code: 'MI' },
  { name: 'Micronesia', code: 'FM' },
  { name: 'Minnesota', code: 'MN' },
  { name: 'Mississippi', code: 'MS' },
  { name: 'Missouri', code: 'MO' },
  { name: 'Montana', code: 'MT' },
  { name: 'Nebraska', code: 'NE' },
  { name: 'Nevada', code: 'NV' },
  { name: 'New Hampshire', code: 'NH' },
  { name: 'New Jersey', code: 'NJ' },
  { name: 'New Mexico', code: 'NM' },
  { name: 'New York', code: 'NY' },
  { name: 'North Carolina', code: 'NC' },
  { name: 'North Dakota', code: 'ND' },
  { name: 'Ohio', code: 'OH' },
  { name: 'Oklahoma', code: 'OK' },
  { name: 'Oregon', code: 'OR' },
  { name: 'Palau', code: 'PW' },
  { name: 'Pennsylvania', code: 'PA' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Rhode Island', code: 'RI' },
  { name: 'South Carolina', code: 'SC' },
  { name: 'South Dakota', code: 'SD' },
  { name: 'Tennessee', code: 'TN' },
  { name: 'Texas', code: 'TX' },
  { name: 'U.S. Virgin Islands', code: 'VI' },
  { name: 'Utah', code: 'UT' },
  { name: 'Vermont', code: 'VT' },
  { name: 'Virginia', code: 'VA' },
  { name: 'Washington', code: 'WA' },
  { name: 'West Virginia', code: 'WV' },
  { name: 'Wisconsin', code: 'WI' },
  { name: 'Wyoming', code: 'WY' },
];

export const levels = [
  { name: '2-year', code: '2-year' },
  { name: '4-year', code: '4-year' },
  { name: 'Less than 2-year', code: 'less t' },
];

export const control = [
  { name: 'Public', code: '1' },
  { name: 'Private non-profit', code: '2' },
  { name: 'Unknown - 3', code: '3' },
];

// Institutional classifications. The dataset stores these in the
// `academicAssociation` field, which can hold a comma-separated combination
// (e.g. "HBCU, HACU"), so filtering/display matches on substring rather than
// exact equality. `label` is the short form shown in the table cell.
export const classifications = [
  { name: 'Historically Black (HBCU)', code: 'HBCU', label: 'HBCU' },
  { name: 'Hispanic-Serving (HSI)', code: 'HACU', label: 'HSI' },
  { name: 'Military & Veteran', code: 'MIL-VET', label: 'Military & Veteran' },
];

// Map a raw `academicAssociation` value (possibly comma-separated) to a short,
// human-readable label for table cells. Unknown codes pass through unchanged.
export function classificationLabel(raw) {
  if (!raw) return '';
  return String(raw)
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .map((code) => classifications.find((c) => c.code === code)?.label || code)
    .join(', ');
}
